import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import PersonalInfo from 'components/forms/PersonalInfo/SSN';
import RealNameInfo from 'components/forms/RealNameInfo';
import values from 'stores/values';
import { NameTypeEnum } from 'types/customer';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { AccountFormutil } from '../../type';

const BaseInfo: FC<ProgressFormProps> = ({ onSubmit }) => {
    const { id_type } = values.getParams<AccountFormutil>();

    const handleSubmit = (ev: FormEvent) => {
        onSubmit('../baseinfo2', ev);

        reportEventList('personalInfo');
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('PERSONAL INFORMATION')}</h3>
            <RealNameInfo nameType={NameTypeEnum.USA} />
            <PersonalInfo
                type="baseinfo"
                idNumberProps={{
                    maskIdNo: null,
                    idType: id_type
                }}
            />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 0.5,
    id: 'baseinfo',
    basePath: 'open',
    ensure: 'account',
    showProgressBar: true,
    eventParams: {
        exposureEventParams: {
            model: '开户-基础信息1',
            name: '基础信息1-页面曝光'
        },
        submitEventParams: {
            model: '开户-基础信息1',
            name: '基础信息1-点击下一步'
        }
    }
})(BaseInfo);
